<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-road"></i> Valor do Km - Followup</h3>
      </div>
    </div>
    <KmValueAdd v-if="showAdd" ref="KmValueAdd" v-on:Back="onBack" />
    <KmValueList v-else ref="KmValueList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import KmValueAdd from './components/add/kmValueAdd.vue'
import KmValueList from './components/list/kmValueList.vue'

export default {
  name: 'KmValue',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    KmValueAdd,
    KmValueList
  },
  mounted () {
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.KmValueAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/kmValue/kmValue.vue